<template>
<div class="chapter">
<div class="inner_page">
<p class="firstcenter">To all the doctoral students past and present<br/>
<br/>
  who have studied under the remarkable scholars who have<br/>
<br/>
  taught in Durham’s theology department<br/>
<br/>
  over the last century.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?6ccfb992